import React, { useState } from 'react';
import ExpandableSection from 'components/ExpandableSection/ExpandableSection';
import ReadOnlyWrapper from 'components/ReadOnlyWrapper/ReadOnlyWrapper';
import { ProFormaQuickStartValues } from 'views/public/ProFormaQuickStart/types';
import { ProFormaModelIds } from 'constants/proForma';
import { DISPOSITION_EXPANDABLE_SECTIONS, HIDE_WARNINGS_KEY } from 'views/ProFormaTable/constants';
import { BOEProFormaDiscrepancies } from 'views/ProFormaTable/types';
import ProFormaForecastTable from './ProFormaForecastTable/ProFormaForecastTable';
import ProFormaSaleProceeds from './ProFormaSaleProceeds/ProFormaSaleProceeds';
import ProFormaAssumptions from './ProFormaAssumptions/ProFormaAssumptions';
import ProFormaValuation from './ProFormaValuation/ProFormaValuation';
import { useProFormaSocketContext } from '../socketContext/ProFormaSocketProvider';
import { APARTMENT_UNIT_TYPE_NAME, NON_APARTMENT_UNIT_TYPE_NAME } from './constants';
import BOEDiscrepancyIcon from '../../BOEDiscrepancyIcon/BOEDiscrepancyIcon';

export interface IProFormaDispositionProps {
    hasWriteAccessToProForma: boolean;
    proFormaSignUpData?: ProFormaQuickStartValues;
    boeDiscrepancies?: BOEProFormaDiscrepancies;
}

const ProFormaDisposition = ({ hasWriteAccessToProForma, proFormaSignUpData, boeDiscrepancies }: IProFormaDispositionProps) => {
    const { proForma, getLocalStorageValueByKey } = useProFormaSocketContext();

    const localStorageHideBOEWarnings = getLocalStorageValueByKey(HIDE_WARNINGS_KEY) ? getLocalStorageValueByKey(HIDE_WARNINGS_KEY) : false;

    const [selectedType, setSelectedType] = useState<string>([ProFormaModelIds.APARTMENT, ProFormaModelIds.APARTMENT_WITH_RETAIL].includes(
        proForma?.proFormaModelId,
    ) ? APARTMENT_UNIT_TYPE_NAME.UNIT : NON_APARTMENT_UNIT_TYPE_NAME.GSF);

    return (
        <ReadOnlyWrapper isReadOnly={!hasWriteAccessToProForma}>
            <ExpandableSection
                number={DISPOSITION_EXPANDABLE_SECTIONS[0].number}
                title={DISPOSITION_EXPANDABLE_SECTIONS[0].title}
                subtitle={DISPOSITION_EXPANDABLE_SECTIONS[0].subtitle}
                className="NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaAssumptions proFormaSignUpData={proFormaSignUpData} />
            </ExpandableSection>
            <ExpandableSection
                number={DISPOSITION_EXPANDABLE_SECTIONS[1].number}
                title={DISPOSITION_EXPANDABLE_SECTIONS[1].title}
                subtitle={DISPOSITION_EXPANDABLE_SECTIONS[1].subtitle}
                className="mt-3 NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaForecastTable />
            </ExpandableSection>
            <ExpandableSection
                number={DISPOSITION_EXPANDABLE_SECTIONS[2].number}
                title={DISPOSITION_EXPANDABLE_SECTIONS[2].title}
                subtitle={DISPOSITION_EXPANDABLE_SECTIONS[2].subtitle}
                className="mt-3 NSCard--level-2"
                isExpanded
                animate
            >
                <ProFormaSaleProceeds selectedType={selectedType} setSelectedType={setSelectedType} />
            </ExpandableSection>
            <ExpandableSection
                number={DISPOSITION_EXPANDABLE_SECTIONS[3].number}
                title={DISPOSITION_EXPANDABLE_SECTIONS[3].title}
                subtitle={DISPOSITION_EXPANDABLE_SECTIONS[3].subtitle}
                className="mt-3 NSCard--level-2"
                warningIcon={(
                    <BOEDiscrepancyIcon
                        section={DISPOSITION_EXPANDABLE_SECTIONS[3].title}
                        metricNames={boeDiscrepancies ? boeDiscrepancies[DISPOSITION_EXPANDABLE_SECTIONS[3].number] : []}
                        className="mr-1 my-auto"
                    />
                )}
                showWarningIcon={boeDiscrepancies && !localStorageHideBOEWarnings
                    ? !!boeDiscrepancies[DISPOSITION_EXPANDABLE_SECTIONS[3].number]?.length : false}
                isExpanded
                animate
            >
                <ProFormaValuation selectedType={selectedType} setSelectedType={setSelectedType} />
            </ExpandableSection>
        </ReadOnlyWrapper>
    );
};

export default ProFormaDisposition;
